var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("agent-status-item-sidebar", {
    attrs: {
      "actions-type": _vm.actionsType,
      statuses: _vm.statusesById,
      "target-key": _vm.targetKey,
      "is-updating-type": _vm.isUpdatingType,
    },
    on: {
      "item-change": _vm.onTargetItemChange,
      create: _vm.onAddAgentStatus,
      update: _vm.onUpdateAgentStatus,
      cancel: _vm.onCancelTargetItem,
      delete: _vm.onDeleteAgentStatus,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }